import { render, staticRenderFns } from "./BusinessBookSelect.vue?vue&type=template&id=e8c24088&scoped=true&"
import script from "./BusinessBookSelect.vue?vue&type=script&lang=js&"
export * from "./BusinessBookSelect.vue?vue&type=script&lang=js&"
import style0 from "./BusinessBookSelect.vue?vue&type=style&index=0&id=e8c24088&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c24088",
  null
  
)

export default component.exports